import { router } from 'expo-router';
import { useState } from 'react';
import { Image } from 'react-native';
import {
    BodyLargeEmphasized,
    Button,
    ButtonSize,
    ButtonVariant,
    Shadows,
    View,
    YStack,
} from 'smoothie';

import billsStackImage from '../../../../assets/images/bills/stack-bills.png';

const BillsReadyForReview = ({ billsCount }) => {
    const [imageWidth, setImageWidth] = useState(0);
    const [imageHeight, setImageHeight] = useState(0);

    return (
        <YStack
            gap={16}
            padding={20}
            borderRadius="$5"
            borderWidth={1}
            borderColor="$gray200"
            flex={1}
            backgroundColor="$white"
            {...Shadows.SMALL}
            onLayout={(event) => {
                const maxWidth = 315;
                const aspectRatio = 132 / 672;
                const baseWidth = (event.nativeEvent.layout.width - 40) * 0.66;
                const width = Math.min(baseWidth, maxWidth);
                const height = Math.min(
                    baseWidth * aspectRatio,
                    maxWidth * aspectRatio,
                );
                setImageWidth(width);
                setImageHeight(height);
            }}
        >
            <View alignItems="flex-start">
                <Image
                    source={billsStackImage}
                    style={{
                        height: imageHeight,
                        width: imageWidth,
                    }}
                />
            </View>
            <BodyLargeEmphasized textAlign="left" width="100%">
                We&apos;ve detected {billsCount} bills
            </BodyLargeEmphasized>
            <View justifyContent="flex-end" flex={1} height="100%" width="100%">
                <Button
                    text="Review"
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    onPress={() => {
                        router.navigate('/bills/bills-discovery');
                    }}
                />
            </View>
        </YStack>
    );
};

export default BillsReadyForReview;
